export default "__VITE_ASSET__B8Ybk6lB__"